// src/components/ui/modal-close-button.tsx
import { cn } from "@u/cn";
import Button from "@ui/button";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ModalCloseButtonProps {
  onClick: () => void;
  className?: string;
  variant?: "default" | "light"; // 'light' para fondos oscuros (Lightbox)
}

export default function ModalCloseButton({
  onClick,
  className,
  variant = "default",
}: ModalCloseButtonProps) {
  const { t } = useTranslation();
  return (
    <Button
      design="glass" // Cambiamos outline por ghost para un botón de cerrar más limpio
      size="icon"
      icon={X}
      aria-label={t("close")}
      onClick={onClick}
      className={cn(
        "h-9 w-9", // rounded-full suele verse mejor en botones de cerrar (opcional)
        variant === "default"
          ? // USANDO SHADCN: Gris semántico que se vuelve rojo semántico al pasar el ratón
            "text-muted-foreground hover:bg-destructive/10 hover:text-destructive"
          : // LIGHTBOX: Se queda con blancos absolutos
            "text-white hover:bg-white/20 hover:text-white",
        className,
      )}
    />
  );
}
